<template>
  <el-row type="flex" class="app-layout orver-hidden-x padding-left-10 padding-right-10">
    <div class="flex-1 flex flex-column event-card">
      <div class="event-form">
        <el-form ref="form" :model="formQuery" label-width="80px" size="mini">
          <el-row :gutter="20" type="flex" class="flex-justify-left">
            <el-col :span="12">
              <el-form-item label="时间">
                <div class="flex">
                  <el-radio-group
                    v-model="dateType"
                    size="mini"
                    @change="handleDateUpdate"
                  >
                    <el-radio-button
                      :label="item.value"
                      v-for="item in dateList"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-radio-button>
                  </el-radio-group>
                  <div class="flex-1 padding-left-20">
                    <el-date-picker
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                      size="mini"
                      class="analyze-relation-range"
                      v-model="formQuery.range"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      :unlink-panels="true"
                      end-placeholder="结束日期"
                      :clearable="false"
                      @change="handleRangeUpdate"
                    />
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="选择部门"
                prop="organizationId"
              >
                <OrganizationCascader
                  v-model="formQuery.organizationId"
                  type="auth"
                  @change="handleOrgabChange"
                  collapseTags
                ></OrganizationCascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" class="flex-justify-left">
            <el-col :span="6">
              <el-form-item label="事件标识">
                <el-input
                  clearable
                  v-model="formQuery.eventCode"
                  placeholder="请输入事件标识"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="事件名称">
                <el-input
                  clearable
                  v-model="formQuery.eventName"
                  placeholder="请输入事件名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="页面路径">
                <el-input
                  clearable
                  v-model="formQuery.pagePath"
                  placeholder="请输入所属页面"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="页面名称">
                <el-input
                  clearable
                  v-model="formQuery.pageName"
                  placeholder="请输入所属页面"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" align="left">
              <el-button size="mini" type="primary" @click="searchTableData(1)">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="padding-bottom-20">
          <el-col align="right">
            <el-button size="mini" @click="showNatData">查看自然属性</el-button>
            <column-switch
              class="margin-left-10 margin-right-10"
              name="EVENT_MANAGE_LIST"
              :columns.sync="columns"
            >
              <el-button size="mini" type="primary">列设置</el-button>
            </column-switch>
            <el-button
              size="mini"
              type="success"
              @click="handleExport"
            >导出</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="event-table flex-1 flex flex-column">
        <el-table
          height="100%"
          :key="columns.length"
          :data="tableData"
          v-loading="queryLoading"
          size="mini"
          stripe
        >
          <template v-for="(item, index) in columnsList">
            <el-table-column
              v-if="columns[item.label]"
              :width="item.width"
              :min-width="item.minWidth"
              :label="item.label"
              :prop="item.prop"
              :key="index"
              :fixed="item.fixed"
              :sortable="item.sortable"
            >
              <template #default="{ row }" v-if="item.tmpl">
                <template v-if="item.label === '事件类型'">
                  {{ LogEvent[row.eventId] }}
                  <el-tag size="mini">
                    {{ row.eventId }}
                  </el-tag>
                </template>
                <template v-if="item.label === '事件名称'">
                  <template v-if="row.eventName">{{ row.eventName }}</template>
                  <el-tag v-else type="info" size="mini">
                    未添加
                  </el-tag>
                </template>
                <template v-if="item.label === '最近触发时间'">
                  <template>{{ row.eventTime | formatTime }}</template>
                </template>
                <template v-if="item.label === '所属页面'">
                  <template v-if="row.pageName">{{ row.pageName }}</template>
                  <template v-else>
                    <el-tag type="info" size="mini">暂无页面名称</el-tag>
                  </template>
                  <br />
                  <small style="color: #C0C4CC">{{ row.pagePath }}</small>
                  <br />
                  <el-image
                    v-if="row.pageImg"
                    style="height: 80px;"
                    :src="row.pageImg"
                    :previewSrcList="[row.pageImg]"
                  >
                  </el-image>
                </template>
                <template v-if="item.label === '操作'">
                  <el-row>
                    <el-col align="center">
                      <!-- <el-button
                        size="mini"
                        type="primary"
                        @click="handleEdit(row)"
                        style="margin-bottom: 10px"
                      >编辑</el-button> -->
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        @click="handleDetail(row)"
                      >查看统计分析</el-button
                      >
                    </el-col>
                  </el-row>
                </template>
              </template>
            </el-table-column>
            <template v-else></template>
          </template>
        </el-table>
        <!-- <el-row class="padding-20">
          <el-col align="right">
            <el-pagination
              class="analyze-users-pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formQuery.pageNum"
              :page-sizes="[20, 50, 100, 200, 300, 400]"
              :page-size="formQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="formQuery.total"
            ></el-pagination>
          </el-col>
        </el-row> -->
      </div>
    </div>
    <el-dialog
      title="自然属性列表"
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
    >
      <el-table
        border
        fit
        :header-cell-style="{ background: '#f5f7fa' }"
        :data="natData"
        style="width: 100%"
      >
        <el-table-column property="code" label="字段"></el-table-column>
        <el-table-column property="name" label="名称"></el-table-column>
        <el-table-column property="app" label="应用"></el-table-column>
        <el-table-column property="desc" label="属性描述"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="编辑事件" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div class="edit-form">
        <el-form
          ref="dialogForm"
          :model="dialogFormQuery"
          label-position="left"
          :rules="rules"
          size="mini"
        >
          <el-form-item prop="eventCode" label="事件标识" label-width="120px">
            <el-input disabled v-model="dialogFormQuery.eventCode"></el-input>
          </el-form-item>
          <el-form-item prop="desc" label="事件描述" label-width="120px">
            <el-input v-model="dialogFormQuery.eventDesc"></el-input>
          </el-form-item>
          <el-form-item prop="name" label="事件名称" label-width="120px">
            <el-input disabled v-model="dialogFormQuery.eventName"></el-input>
          </el-form-item>
          <el-form-item label="所属页面" label-width="120px">
            <div class="flex" style="color: #999;flex-wrap: wrap">
              <small class="padding-right-20 align-left">
                {{ dialogFormQuery.pagePath || '/' }}</small
              >
              <br />
              <small class="padding-right-20 align-left">
                {{ dialogFormQuery.pageName || '/' }}</small
              >
            </div>
          </el-form-item>
          <el-form-item label="页面位置示意图" label-width="120px" prop="images">
            <p align="left" style="color: #999;">
              <small>示意图上传之后只做更新操作，不允许删除</small>
            </p>
            <Upload
              :paste="false"
              :limit="1"
              accept=".jpg, .jpeg, .png"
              :file-list="pageImgList"
              multiple
              @update="handleUploadUpdate"
            >
            </Upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" v-loading="queryLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      title="我是标题"
      :visible.sync="drawer.visible"
      :with-header="false"
      append-to-body
      destroy-on-close
      modal-append-to-body
      size="90%"
    >
      <Analysis :query="drawer.query" />
    </el-drawer>
  </el-row>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { queryEventAgg, modifyEvent, eventAnalyzeExport } from '@/api/event';
import { LogEvent } from '@/data/log';
import exportByBlobMixsin from '@/mixins/file-download';
import Upload from '@/components/upload';
import OrganizationCascader from '@/views/components/organization-cascader/index.vue';
import Analysis from '../analysis/index.vue';

export default {
  components: {
    Upload,
    OrganizationCascader,
    Analysis,
  },
  mixins: [exportByBlobMixsin],
  data() {
    return {
      LogEvent,
      drawer: {
        visible: false,
        query: {

        },
      },
      queryLoading: false,
      images: [],
      dateType: '0',
      dateList: [{
        value: '0',
        label: '今日',
      }, {
        value: '1',
        label: '昨日',
      }, {
        value: '2',
        label: '最近7天',
      }, {
        value: '3',
        label: '最近30天',
      }],
      dialogImageUrl: '',
      dialogVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      rules: {
        eventCode: [{ required: true, message: '事件标识不能为空', trigger: 'blur' }],
        eventDesc: [{ required: true, message: '事件描述不能为空', trigger: 'blur' }],
        eventName: [{ required: true, message: '事件名称不能为空', trigger: 'blur' }],
      },
      form: {
        name: '',
      },
      tableData: [],
      natData: [
        {
          code: 'source',
          name: '应用标识/数据来源',
          app: 'Web，小程序，APP',
          desc: '应用唯一标识，用于上报数据归属；类型是数字枚举',
        },
        {
          code: 'lib',
          name: '应用类型',
          app: 'Web，小程序，APP',
          desc: '应用类型：App（移动app），MiniProgram（小程序），BPS1/BPS（Web统称）',
        },
        {
          code: 'libVersion',
          name: '应用版本',
          app: '小程序，APP',
          desc: '应用版本',
        },
        {
          code: 'os',
          name: '系统类型',
          app: 'Web，小程序，APP',
          desc: '访问设备/终端的型号',
        },
        {
          code: 'osVersion',
          name: '系统版本',
          app: 'Web，小程序，APP',
          desc: '访问设备/终端的版本',
        },
        {
          code: 'browserName',
          name: '浏览器类型',
          app: 'Web',
          desc: '浏览器类型，如：chrome、Firefox、Edge',
        },
        {
          code: 'browserVersion',
          name: '浏览器版本',
          app: 'Web',
          desc: '浏览器版本',
        },
        {
          code: 'userId',
          name: '用户ID',
          app: 'Web，小程序，APP',
          desc: '用户唯一标识',
        },
        {
          code: 'userName',
          name: '用户名称',
          app: 'Web，小程序，APP',
          desc: '用户名称',
        },
        {
          code: 'eventCode',
          name: '事件code',
          app: 'Web，小程序，APP',
          desc: '事件上报唯一标识',
        },
        {
          code: 'pagePath',
          name: '页面路径',
          app: 'Web，小程序，APP',
          desc: '事件所属页面路径',
        },
        {
          code: 'pageName',
          name: '页面名称',
          app: 'Web，小程序，APP',
          desc: '事件所属页面名称',
        },
        {
          code: 'visitorId',
          name: '访客ID',
          app: 'Web，小程序，APP',
          desc: '访客跟踪ID，首次登陆以随机数生成，登陆之后以userId替代随机数进行跟中',
        },
      ],
      columnsList: [
        {
          label: '事件类型',
          minWidth: 150,
          tmpl: true,
        },
        {
          label: '事件标识',
          minWidth: 150,
          prop: 'eventCode',
        },
        {
          label: '事件名称',
          minWidth: 150,
          prop: 'eventName',
          tmpl: true,
        },
        {
          label: '事件描述',
          prop: 'eventDesc',
        },
        {
          label: '所属页面',
          tmpl: true,
        },
        {
          label: '触发总次数',
          minWidth: 100,
          prop: 'eventCount',
        },
        {
          label: '用户数',
          prop: 'userCount',
        },
        {
          label: '最近触发时间',
          minWidth: 100,
          tmpl: true,
        },
        {
          label: '操作',
          tmpl: true,
          minWidth: 150,
        },
      ],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf- 8 ',
          },
        ],
      ],
      json_fields: {
        事件类型: {
          field: 'eventId',
          callback: (value) => `${LogEvent[value]}(${value})`,
        }, // 常规字段
        事件标识: 'eventCode',
        事件名称: 'eventName', // 支持嵌套属性
        事件描述: 'eventDesc',
        所属页面: 'pageName',
        所属页面路径: 'pagePath',
        触发总次数: 'eventCount',
        用户数: 'userCount',
        最近触发时间: 'eventTime',
      },
      columns: {
        事件类型: true,
        事件名称: true,
        事件标识: true,
        事件描述: true,
        所属页面: true,
        触发总次数: true,
        用户数: true,
        最近触发时间: true,
        操作: true,
      },
      formQuery: {
        organizationId: [],
        range: [],
        pageNum: 1,
        pageSize: 100,
        total: 0,
        pagePath: '',
        pageName: '',
        eventName: '',
        eventCode: '',
      },
      dialogFormQuery: {
        id: '',
        pagePath: '',
        eventName: '',
        eventCode: '',
        eventDesc: '',
        pageImg: '',
      },
      pageImgList: [],
    };
  },
  mounted() {
    this.setDefaultRange();
    this.searchTableData();
  },
  watch: {
    source: {
      handler() {
        this.searchTableData();
      },
    },
    env: {
      handler() {
        this.searchTableData();
      },
    },
  },
  methods: {
    handleExport() {
      const {
        pagePath,
        pageName,
        eventName,
        eventCode,
        pageNum,
        pageSize,
        organizationId,
        range: [analyzeTimeFrom, analyzeTimeTo],
      } = this.formQuery;

      console.log(organizationId);
      const data = {
        downloadType: 'page',
        analyzeTimeFrom,
        analyzeTimeTo,
        pageNum,
        pageSize,
        pageName,
        pagePath,
        eventName,
        eventCode,
        organizationIdList: [].concat(...organizationId),
      };
      this.exportByBlob({
        url: eventAnalyzeExport,
        data,
      });
    },
    handleOrgabChange(e) {
      console.log(e);
    },
    handleRangeUpdate() {
      this.dateType = '';
    },
    /**
     * 设置默认的时间周期
     */
    setDefaultRange() {
      this.handleDateUpdate();
    },
    // 日期快捷操作
    handleDateUpdate() {
      let days = 0;
      let lastDays = 0;
      switch (this.dateType) {
        case '0': days = 0; break;
        case '1': days = 1; lastDays = 1; break;
        case '2': days = 7; break;
        case '3': days = 30; break;
        default: break;
      }
      this.formQuery.range = [
        `${moment().subtract(days, 'days').format('YYYY-MM-DD')}`,
        `${moment().subtract(lastDays, 'days').format('YYYY-MM-DD')}`,
      ];
    },
    // 营业执照图片上传成功后的回调方法；
    handleUploadUpdate(obj) {
      this.pageImgList.splice(0, 1, ...obj);
      this.dialogFormQuery.pageImg = obj.map(({ url }) => url).join(',');
    },
    handleSizeChange(size) {
      this.formQuery.pageSize = size;
      this.formQuery.pageNum = 1;
      this.searchTableData();
    },
    handleCurrentChange(num) {
      this.formQuery.pageNum = num;
      this.searchTableData();
    },
    async searchTableData(currentPageNum) {
      if (currentPageNum) {
        this.formQuery.pageNum = currentPageNum;
      }
      try {
        this.queryLoading = true;

        // eslint-disable-next-line object-curly-newline
        const {
          pagePath,
          pageName,
          eventName,
          eventCode,
          pageNum,
          pageSize,
          organizationId,
          range: [analyzeTimeFrom, analyzeTimeTo],
        } = this.formQuery;

        console.log(organizationId);
        const params = {
          analyzeTimeFrom,
          analyzeTimeTo,
          pageNum,
          pageSize,
          pageName,
          pagePath,
          eventName,
          eventCode,
          organizationIdList: [].concat(...organizationId),
        };

        const {
          data: { events, total },
        } = await queryEventAgg(params);
        this.formQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...events);
      } finally {
        this.queryLoading = false;
      }
    },
    handleSubmit() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          this.queryLoading = true;
          try {
            // eslint-disable-next-line object-curly-newline
            const { pagePath, eventName, eventCode, eventDesc, pageImg, id } = this.dialogFormQuery;
            const data = {
              pagePath,
              eventName,
              eventCode,
              eventDesc,
              pageImg,
              id,
            };
            await modifyEvent(data);
            this.$message.success('编辑成功');
            this.searchTableData();
            this.dialogFormVisible = false;
          } catch (error) {
            console.error(error);
          } finally {
            this.queryLoading = false;
          }
        }
      });
    },
    handleEdit(row) {
      console.log(row);
      Object.assign(this.dialogFormQuery, {
        id: row.id,
        pagePath: row.pagePath,
        eventName: row.eventName,
        eventCode: row.eventCode,
        eventDesc: row.eventDesc,
        pageName: row.pageName,
        pageImg: row.pageImg,
      });
      this.pageImgList.splice(0);

      if (row.pageImg) {
        this.pageImgList.push({ url: row.pageImg });
      }

      this.dialogFormVisible = true;
    },
    // eslint-disable-next-line object-curly-newline
    handleDetail({ eventId, eventCode, eventName, pageName }) {
      // this.$router.push({
      //   path: '/event-manage/eventAnalysis',
      //   query: {
      //     eventId,
      //     eventCode,
      //     eventName,
      //     pageName,
      //   },
      // });
      Object.assign(this.drawer, {
        visible: true,
        query: {
          eventId,
          eventCode,
          eventName,
          pageName,
          organizationId: [...this.formQuery.organizationId],
          range: this.formQuery.range,
          dateType: this.dateType,
        },
      });
    },
    showNatData() {
      this.dialogTableVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.images = fileList;
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadSuccess(response, file, fileList) {
      console.log(fileList);
      this.images = fileList;
    },
  },
  computed: {
    ...mapGetters('app', ['env', 'source']),
  },
};
</script>
<style lang="scss" scoped>
.app-layout {
  margin-top: 10px;
  height: calc(100vh - 90px);
  flex-direction: column;
  .flex-table {
    flex: 1;
  }
}
.event-card {
  background: #fff;
  padding: 20px;
  &::v-deep {
    .el-card__body {
      height: 100%;
      flex-direction: column;
      display: flex;
    }
  }
}
.edit-form {
  width: 90%;
  margin: 0 auto;
}
</style>
<style lang="scss">
.disabled {
  .el-upload--picture-card {
    display: none !important;
  }
}
</style>
